<template>
    <div class="mx-2 mb-2">
        <BRow>
            <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
                <span class="text-muted">{{ `Mostrando ${pagination.from} de ${pagination.to} de ${pagination.of} entradas` }}</span>
            </BCol>
            <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
                <BPagination :value="currentPage" @input="updateCurrentPage($event)" :total-rows="total" :per-page="perPage" first-number last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                    <template #prev-text> 
                        <FeatherIcon icon="ChevronLeftIcon" size="18" /> 
                    </template>
                    <template #next-text> 
                        <FeatherIcon icon="ChevronRightIcon" size="18" /> 
                    </template>
                </BPagination>
            </BCol>
        </BRow>
    </div>
</template>

<script>
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue';
import { BCol, BPagination, BRow } from 'bootstrap-vue';

export default {
    props: [
        'pagination', 'total', 'perPage', 'currentPage'
    ],
    components: {
        BCol, BPagination, BRow, FeatherIcon
    },
    setup(props, { emit }) {
        const updateCurrentPage = function(event) {
            emit('update:currentPage', event)
        }

        return {
            updateCurrentPage
        }
    }
}
</script>